import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import Select from "../common/form/select";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import { bindActionCreators } from "redux";
import BotaoExcluir from "../common/button/botaoExcluir";
import NumberFormat from "react-number-format";
import avatarGradiosPositivo from "../assets/images/avatar_gradios_positivo.png";
import avatarGradiosNegativo from "../assets/images/avatar_gradios_negativo.png";
import { listarMesesAnosEntreCompetencias } from "../utils/listarMesesAnosEntreCompetencias";
import { buscarTarifasSimulacaoOptante, setTarifasSimulacaoAneel } from "./diagnosticoEnergiaActions";
import Button from "../common/button/button";
import Grid from "../common/layout/grid";
import { ModalAlert } from "../common/dialog/modalAlert";

function RenderizarAnaliseOpcaoTarifariaOptanteBA(props) {
    const [state, setState] = useState({ tarifasApi: {}, demandas: [] });
    const [exibirModalDemanda, setExibirModalDemanda] = useState(false);

    const backgroundColor = "#58c5fb";
    const color = "#08354c";
    const corValorEditado = "#008fd7";

    const qtdTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_fora_ponta), 0);
    const qtdTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_ponta), 0);

    const tusdMaisTeForaPonta =
        (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_tusd) || 0) + (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_te) || 0);
    const tusdMaisTePonta = (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_ponta_tusd) || 0) + (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_ponta_te) || 0);

    const valorEnergiaExcedenteForaPonta = qtdTotalExcedenteForaPonta * -1 * tusdMaisTeForaPonta;
    const valorEnergiaExcedentePonta = qtdTotalExcedentePonta * -1 * tusdMaisTePonta;

    //SIMULA QUANTIDADE E VALOR DE ENERGIA FP e P
    const qtdEnergiaTotalEnergia = (parseFloat(props.dados.quantidade_energia_fora_ponta) || 0) + (parseFloat(props.dados.quantidade_energia_ponta) || 0);

    const qtdEnergiaReservado = parseFloat(props.dados.quantidade_energia_reservado) || 0;
    const tarifaTusdReservado = (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_tusd) || 0) * 0.3;
    const tarifaTeReservado = (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_te) || 0) * 0.3; //0.3 pq tem 70% de desconto
    const valorEnergiaReservadoTusd = qtdEnergiaReservado * tarifaTusdReservado; //0.3 pq tem 70% de desconto
    const valorEnergiaReservadoTe = qtdEnergiaReservado * tarifaTeReservado;

    const qtdSimuladaEnergiaForaPonta = state.percentual_energia_ponta ? qtdEnergiaTotalEnergia * ((100 - (state.percentual_energia_ponta || 0)) / 100) : qtdEnergiaTotalEnergia;
    const tarifaForaPontaTusd = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_tusd) || 0;
    const tarifaForaPontaTe = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_te) || 0;
    const valorSimuladoEnergiaForaPontaTusd = qtdSimuladaEnergiaForaPonta * tarifaForaPontaTusd;
    const valorSimuladoEnergiaForaPontaTe = qtdSimuladaEnergiaForaPonta * tarifaForaPontaTe;

    const qtdSimuladaEnergiaPonta = state.percentual_energia_ponta ? qtdEnergiaTotalEnergia * ((state.percentual_energia_ponta || 0) / 100) : 0;
    const tarifaPontaTusd = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_ponta_tusd) || 0;
    const tarifaPontaTe = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_ponta_te) || 0;
    const valorSimuladoEnergiaPontaTusd = qtdSimuladaEnergiaPonta * tarifaPontaTusd;
    const valorSimuladoEnergiaPontaTe = qtdSimuladaEnergiaPonta * tarifaPontaTe;

    const qtdDemandaSimulada = state.demandas.reduce((acc, item) => (acc += parseFloat(item.valor) || 0), 0);
    const tarifaDemandaTusd = parseFloat(props.tarifasAneelSimulacao.tarifa_demanda_tusd) || 0;
    const tarifaDemandaTe = parseFloat(props.tarifasAneelSimulacao.tarifa_demanda_te) || 0;
    const valorSimuladoDemandaTusd = qtdDemandaSimulada * tarifaDemandaTusd;
    const valorSimuladoDemandaTe = qtdDemandaSimulada * tarifaDemandaTe;

    const totalSituacaoAtual =
        (parseFloat(props.situacaoAtual.valor_energia_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_fora_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_reservado) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_fora_ponta) || 0) +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
        (parseFloat(props.situacaoAtual.valor_imposto) || 0) +
        (parseFloat(props.situacaoAtual.valor_bandeira) || 0);

    const subtotal =
        valorSimuladoEnergiaForaPontaTusd +
        valorSimuladoEnergiaForaPontaTe +
        valorSimuladoEnergiaPontaTusd +
        valorSimuladoEnergiaPontaTe +
        valorEnergiaReservadoTusd +
        valorEnergiaReservadoTe +
        valorEnergiaExcedenteForaPonta +
        valorEnergiaExcedentePonta +
        valorSimuladoDemandaTusd +
        valorSimuladoDemandaTe +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0);

    const totalImposto = (props.dados.aliquota_pis_pasep / 100) * subtotal + (props.dados.aliquota_cofins / 100) * subtotal + (props.dados.aliquota_icms / 100) * subtotal;

    const totalComImposto = subtotal + totalImposto;

    const percentualEconomizado = ((totalSituacaoAtual - totalComImposto) * 100) / totalSituacaoAtual;

    const listaMeses = listarMesesAnosEntreCompetencias(props.filtro.competencia_inicial, props.filtro.competencia_final);
    const listaAnos = listaMeses.reduce((acc, item) => {
        if (!acc.includes(item.ano)) {
            acc.push(item.ano);
        }
        return acc;
    }, []);

    const nomeMeses = {
        "01": "Janeiro",
        "02": "Fevereiro",
        "03": "Março",
        "04": "Abril",
        "05": "Maio",
        "06": "Junho",
        "07": "Julho",
        "08": "Agosto",
        "09": "Setembro",
        10: "Outubro",
        11: "Novembro",
        12: "Dezembro",
    };

    const camposDemandaMemo = useMemo(() => {
        return listaAnos.map((ano, i) => (
            <Row key={ano} style={{ backgroundColor: i % 2 === 0 ? "#f8f9fa" : "#ffffff", padding: 8, borderRadius: 4, marginBottom: 4 }}>
                <Grid
                    cols="12 12 2 2"
                    style={{
                        display: "flex",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: i % 2 === 0 ? "#e3e4ec" : "#f4f4f5",
                        borderRadius: 4,
                    }}
                >
                    {ano}
                </Grid>
                <Grid cols="12 12 10 10">
                    <Row>
                        {Array.from({ length: 3 }, (_, i) => i + 1).map((linha) =>
                            Array.from({ length: 4 }, (_, j) => j + 1).map((coluna) => {
                                const mes = (linha - 1) * 4 + coluna;
                                const mesFormatado = mes < 10 ? "0" + mes : mes.toString();
                                const mesEstaNaLista = listaMeses.find((item) => item.ano == ano && item.mes == mes);
                                const competencia = `${ano}${mesFormatado}`;
                                const itemDemanda = state.demandas.find((item) => item.competencia === competencia);
                                const valorCampo = itemDemanda ? itemDemanda.valor : 0;
                                return (
                                    <Grid key={`${ano}-${mes}`} cols="12 12 3 3" style={{ marginBottom: 15 }}>
                                        <div style={{ marginBottom: 4, fontWeight: "bolder" }}>{nomeMeses[mesFormatado]}</div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={!mesEstaNaLista}
                                            placeholder={"0,00"}
                                            decimalSeparator={","}
                                            decimalScale={2}
                                            fixedDecimalScale={2}
                                            value={String(valorCampo).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                setState({
                                                    ...state,
                                                    demandas: [...state.demandas.filter((d) => d.competencia != competencia), { competencia, valor }],
                                                });
                                            }}
                                        />
                                    </Grid>
                                );
                            })
                        )}
                    </Row>
                </Grid>
            </Row>
        ));
    }, [listaAnos, listaMeses]);

    return (
        <div style={{ backgroundColor: "#FFF", borderRadius: 8 }}>
            {exibirModalDemanda && (
                <ModalAlert
                    titulo={`Defina a quantidade de demanda para cada mês`}
                    handleClose={() => {
                        setExibirModalDemanda(false);
                    }}
                >
                    {camposDemandaMemo}
                    <Row>
                        <Grid cols="12 12 6 6" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Button
                                style={{ width: "100%" }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Salvar</span>}
                                title="Salvar"
                                type={"success"}
                                icon={"fa fa-check"}
                                event={() => {
                                    setExibirModalDemanda(false);
                                }}
                            />
                        </Grid>
                        <Grid cols="12 12 6 6" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Button
                                style={{ width: "100%" }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Limpar</span>}
                                title="Limpar"
                                type={"danger"}
                                icon={"fas fa-eraser"}
                                event={() => {
                                    setState({ ...state, demandas: [] });
                                    setExibirModalDemanda(false);
                                }}
                            />
                        </Grid>
                    </Row>
                </ModalAlert>
            )}

            <Table id={props.id} minHeight="fit-content" responsive padding={6} borderRadius={25}>
                <THead>
                    <Tr>
                        <Th colSpan={5} alignCenter maxHeight="100%" backgroundColor={backgroundColor} color="#FFF" style={{ padding: 6 }}>
                            <div className="d-flex">
                                <div style={{ flexGrow: "1" }}>Opção Faturar em A</div>
                                <div>
                                    <BotaoExcluir event={() => props.removerAnalise({ tipoAnalise: "Opção Tarifária (Optante A ou B)" })} />
                                </div>
                            </div>
                        </Th>
                    </Tr>
                </THead>

                <TBody>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td width={200} backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Tipo de mercado
                        </Td>
                        <Td width={120} alignCenter colSpan={3}>
                            {props.ucFiltrada.nome_tipo_mercado ? props.ucFiltrada.nome_tipo_mercado : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Grupo de Faturamento
                        </Td>
                        <Td width={120} alignCenter colSpan={3}>
                            Grupo A Faturado em A (Optante com Demanda)
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            <div className="my-3">Tarifa Aplicada ANEEL por kWh</div>
                            <Row>
                                <Select
                                    name="nome_subgrupo_faturamento"
                                    options={props.listaSubgrupoFaturamento
                                        .filter((item) => item.ids_grupo_faturamento.includes(4)) //Grupo A Fat em A
                                        .map((item) => ({ id: item.valor, valor: item.valor }))}
                                    label="Subgrupo de Faturamento"
                                    cols="12 12 12 12"
                                    placeholder="Subgrupo"
                                    isClearable={true}
                                    value={state.nome_subgrupo_faturamento}
                                    onChange={(data) => {
                                        setState({
                                            ...state,
                                            nome_subgrupo_faturamento: data,
                                        });
                                    }}
                                />
                                <Select
                                    name="nome_modalidade_tarifaria"
                                    options={props.listaModalidadeTarifaria.map((item) => ({ id: item.valor, valor: item.valor }))}
                                    label="Modalidade Tarifária"
                                    cols="12 12 12 12"
                                    placeholder="Modalidade"
                                    isClearable={true}
                                    value={state.nome_modalidade_tarifaria}
                                    onChange={(data) => {
                                        setState({
                                            ...state,
                                            nome_modalidade_tarifaria: data,
                                        });
                                    }}
                                />
                                <Grid cols="12 12 12 12" style={{ display: "flex", alignItems: "center" }}>
                                    <Button
                                        title="Buscar Tarifas ANEEL"
                                        disabled={!state.nome_subgrupo_faturamento || !state.nome_modalidade_tarifaria}
                                        text={"Buscar"}
                                        type={"primary"}
                                        solid={true}
                                        style={{ margin: 0, padding: 8 }}
                                        event={() => {
                                            props.buscarTarifasSimulacaoOptante(state, (tarifasApi) => {
                                                if (!tarifasApi) return;
                                                setState({ ...state, tarifasApi: { ...tarifasApi } });
                                            });
                                        }}
                                    />
                                </Grid>
                            </Row>
                        </Td>
                        <Td width={120} alignCenter colSpan={3}>
                            <Row>
                                <Grid cols="12 12 4 4" style={{ marginTop: 5 }}>
                                    <div>Vigência F. Ponta</div>
                                    {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia_fora_ponta &&
                                    props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia_fora_ponta ? (
                                        <div style={{ fontSize: "0.7rem", marginTop: 5 }}>
                                            {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia_fora_ponta +
                                                " à " +
                                                props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia_fora_ponta || " - "}
                                        </div>
                                    ) : (
                                        " - "
                                    )}
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TUSD Fora Ponta</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_tusd || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_fora_ponta_tusd: valor,
                                                    data_inicio_vigencia_tarifa_energia_fora_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_fora_ponta_tusd
                                                            ? null
                                                            : state.tarifasApi.data_inicio_vigencia_tarifa_energia_fora_ponta,
                                                    data_fim_vigencia_tarifa_energia_fora_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_fora_ponta_tusd
                                                            ? null
                                                            : state.tarifasApi.data_fim_vigencia_tarifa_energia_fora_ponta,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TE Fora Ponta</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_fora_ponta_te || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_fora_ponta_te: valor,
                                                    data_inicio_vigencia_tarifa_energia_fora_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_fora_ponta_te
                                                            ? null
                                                            : state.tarifasApi.data_inicio_vigencia_tarifa_energia_fora_ponta,
                                                    data_fim_vigencia_tarifa_energia_fora_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_fora_ponta_te
                                                            ? null
                                                            : state.tarifasApi.data_fim_vigencia_tarifa_energia_fora_ponta,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Row>
                            <Row>
                                <Grid cols="12 12 4 4" style={{ marginTop: 5 }}>
                                    <div>Vigência Ponta</div>
                                    {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia_ponta && props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia_ponta ? (
                                        <div style={{ fontSize: "0.7rem", marginTop: 5 }}>
                                            {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia_ponta +
                                                " à " +
                                                props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia_ponta || " - "}
                                        </div>
                                    ) : (
                                        " - "
                                    )}
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TUSD Ponta</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_ponta_tusd || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_ponta_tusd: valor,
                                                    data_inicio_vigencia_tarifa_energia_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_ponta_tusd ? null : state.tarifasApi.data_inicio_vigencia_tarifa_energia_ponta,
                                                    data_fim_vigencia_tarifa_energia_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_ponta_tusd ? null : state.tarifasApi.data_fim_vigencia_tarifa_energia_ponta,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TE Ponta</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_ponta_te || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_ponta_te: valor,
                                                    data_inicio_vigencia_tarifa_energia_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_ponta_te ? null : state.tarifasApi.data_inicio_vigencia_tarifa_energia_ponta,
                                                    data_fim_vigencia_tarifa_energia_ponta:
                                                        valor !== state.tarifasApi.tarifa_energia_ponta_te ? null : state.tarifasApi.data_fim_vigencia_tarifa_energia_ponta,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Row>
                            <Row>
                                <Grid cols="12 12 4 4" style={{ marginTop: 8 }}>
                                    <div>Vigência Dem.</div>
                                    {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_demanda && props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_demanda ? (
                                        <div style={{ fontSize: "0.7rem", marginTop: 5 }}>
                                            {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_demanda +
                                                " à " +
                                                props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_demanda || " - "}
                                        </div>
                                    ) : (
                                        " - "
                                    )}
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>Dem. TUSD</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_demanda_tusd || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_demanda_tusd: valor,
                                                    data_inicio_vigencia_tarifa_demanda:
                                                        valor !== state.tarifasApi.tarifa_demanda_tusd ? null : state.tarifasApi.data_inicio_vigencia_tarifa_demanda,
                                                    data_fim_vigencia_tarifa_demanda:
                                                        valor !== state.tarifasApi.tarifa_demanda_tusd ? null : state.tarifasApi.data_fim_vigencia_tarifa_demanda,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>Dem. TE</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_demanda_te || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_demanda_te: valor,
                                                    data_inicio_vigencia_tarifa_demanda:
                                                        valor !== state.tarifasApi.tarifa_demanda_te ? null : state.tarifasApi.data_inicio_vigencia_tarifa_demanda,
                                                    data_fim_vigencia_tarifa_demanda:
                                                        valor !== state.tarifasApi.tarifa_demanda_te ? null : state.tarifasApi.data_fim_vigencia_tarifa_demanda,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Row>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Digite o percentual de energia ponta (%)
                        </Td>
                        <Td colSpan={3}>
                            <NumberFormat
                                className="form-control"
                                disabled={false}
                                placeholder={"0,00%"}
                                decimalSeparator={","}
                                decimalScale={2}
                                fixedDecimalScale={2}
                                value={String(state.percentual_energia_ponta || 0).replace(".", ",")}
                                onValueChange={(values) => {
                                    const valor = values.floatValue || 0;
                                    setState({
                                        ...state,
                                        percentual_energia_ponta: valor,
                                    });
                                }}
                            />
                        </Td>
                    </Tr>
                    <Tr>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            <Button
                                text="Digite a quantidade de Demanda (kWh)"
                                type={"dark"}
                                icon={"fas fa-keyboard"}
                                style={{ margin: 0 }}
                                event={() => {
                                    setExibirModalDemanda(true);
                                }}
                            />
                        </Td>
                        <Td colSpan={3}>
                            <NumberFormat
                                className="form-control"
                                disabled={true}
                                placeholder={"0,00"}
                                decimalSeparator={","}
                                decimalScale={2}
                                fixedDecimalScale={2}
                                value={String(qtdDemandaSimulada || 0).replace(".", ",")}
                            />
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Descrição
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" alignCenter>
                            Quantidade
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" alignCenter>
                            Tarifa
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={120} alignCenter>
                            R$
                        </Td>
                    </Tr>

                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                            Energia Fora Ponta
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TUSD
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdSimuladaEnergiaForaPonta ? adicionarPontosMilhar(qtdSimuladaEnergiaForaPonta, 2) + " kWh" : " - "}
                        </Td>

                        <Td width={100} alignCenter>
                            {tarifaForaPontaTusd ? "R$ " + adicionarPontosMilhar(tarifaForaPontaTusd, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoEnergiaForaPontaTusd ? "R$ " + adicionarPontosMilhar(valorSimuladoEnergiaForaPontaTusd, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdSimuladaEnergiaForaPonta ? adicionarPontosMilhar(qtdSimuladaEnergiaForaPonta, 2) + " kWh" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaForaPontaTe ? "R$ " + adicionarPontosMilhar(tarifaForaPontaTe, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoEnergiaForaPontaTe ? "R$ " + adicionarPontosMilhar(valorSimuladoEnergiaForaPontaTe, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                            Energia Ponta
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TUSD
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdSimuladaEnergiaPonta ? adicionarPontosMilhar(qtdSimuladaEnergiaPonta, 2) + " kWh" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaPontaTusd ? "R$ " + adicionarPontosMilhar(tarifaPontaTusd, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoEnergiaPontaTusd ? "R$ " + adicionarPontosMilhar(valorSimuladoEnergiaPontaTusd, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdSimuladaEnergiaPonta ? adicionarPontosMilhar(qtdSimuladaEnergiaPonta, 2) + " kWh" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaPontaTe ? "R$ " + adicionarPontosMilhar(tarifaPontaTe, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoEnergiaPontaTe ? "R$ " + adicionarPontosMilhar(valorSimuladoEnergiaPontaTe, 6) : " - "}
                        </Td>
                    </Tr>
                    {!!props.ucFiltrada.irrigante && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                                    Energia Reservado
                                </Td>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TUSD
                                </Td>
                                <Td width={150} alignCenter>
                                    {qtdEnergiaReservado ? adicionarPontosMilhar(qtdEnergiaReservado, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {tarifaTusdReservado ? "R$ " + adicionarPontosMilhar(tarifaTusdReservado, 6) : " - "}
                                </Td>
                                <Td width={120} alignCenter>
                                    {valorEnergiaReservadoTusd ? "R$ " + adicionarPontosMilhar(valorEnergiaReservadoTusd, 6) : " - "}
                                </Td>
                            </Tr>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TE
                                </Td>
                                <Td width={150} alignCenter>
                                    {qtdEnergiaReservado ? adicionarPontosMilhar(qtdEnergiaReservado, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {tarifaTeReservado ? "R$ " + adicionarPontosMilhar(tarifaTeReservado, 6) : " - "}
                                </Td>
                                <Td width={120} alignCenter color={props.dados.valor_energia_mercado_livre_por_mwh ? corValorEditado : null}>
                                    {valorEnergiaReservadoTe ? "R$ " + adicionarPontosMilhar(valorEnergiaReservadoTe, 6) : " - "}
                                </Td>
                            </Tr>
                        </>
                    )}
                    {!!(props.ucFiltrada.geracao || props.ucFiltrada.id_unidade_geradora) && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Fora Ponta
                                </Td>
                                <Td width={150} alignCenter>
                                    {qtdTotalExcedenteForaPonta ? adicionarPontosMilhar(qtdTotalExcedenteForaPonta, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {tusdMaisTeForaPonta ? "R$ " + adicionarPontosMilhar(tusdMaisTeForaPonta, 6) : " - "}
                                </Td>
                                <Td width={120} alignCenter>
                                    {valorEnergiaExcedenteForaPonta ? "R$ " + adicionarPontosMilhar(valorEnergiaExcedenteForaPonta, 6) : " - "}
                                </Td>
                            </Tr>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Ponta
                                </Td>
                                <Td width={150} alignCenter>
                                    {qtdTotalExcedentePonta ? adicionarPontosMilhar(qtdTotalExcedentePonta, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {tusdMaisTePonta ? "R$ " + adicionarPontosMilhar(tusdMaisTePonta, 6) : " - "}
                                </Td>
                                <Td width={120} alignCenter>
                                    {valorEnergiaExcedentePonta ? "R$ " + adicionarPontosMilhar(valorEnergiaExcedentePonta, 6) : " - "}
                                </Td>
                            </Tr>
                        </>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            Demanda Fora Ponta
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            {/* TUSD */}
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdDemandaSimulada ? adicionarPontosMilhar(qtdDemandaSimulada, 2) + " kW" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaDemandaTusd ? "R$ " + adicionarPontosMilhar(tarifaDemandaTusd, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoDemandaTusd ? "R$ " + adicionarPontosMilhar(valorSimuladoDemandaTusd, 6) : " - "}
                        </Td>
                    </Tr>
                    {/* <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={150} alignCenter>
                            {qtdDemandaSimulada ? adicionarPontosMilhar(qtdDemandaSimulada, 2) + " kW" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaDemandaTe ? "R$ " + adicionarPontosMilhar(tarifaDemandaTe, 6) : " - "}
                        </Td>
                        <Td width={120} alignCenter>
                            {valorSimuladoDemandaTe ? "R$ " + adicionarPontosMilhar(valorSimuladoDemandaTe, 6) : " - "}
                        </Td>
                    </Tr> */}
                    {props.exibirUltrapassagemDemanda && (
                        <Tr style={{ fontWeight: "450" }}>
                            <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                Ultrapassagem de Demanda Fora Ponta
                            </Td>

                            <Td width={150} alignCenter>
                                -
                            </Td>

                            <Td width={100} alignCenter>
                                {props.dados.quantidade_ultrapassagem_demanda_fora_ponta
                                    ? adicionarPontosMilhar(props.dados.quantidade_ultrapassagem_demanda_fora_ponta, 2) + " kW"
                                    : " - "}
                            </Td>
                            <Td width={120} alignCenter>
                                {props.dados.valor_ultrapassagem_demanda_fora_ponta
                                    ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                        ? "R$ " +
                                          adicionarPontosMilhar(
                                              props.dados.valor_ultrapassagem_demanda_fora_ponta -
                                                  (props.dados.percentual_mercado_livre / 100) * props.dados.valor_ultrapassagem_demanda_fora_ponta,
                                              6
                                          )
                                        : "R$ " + adicionarPontosMilhar(props.dados.valor_ultrapassagem_demanda_fora_ponta, 6)
                                    : " - "}
                            </Td>
                        </Tr>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td
                            backgroundColor="#ecf5fd"
                            color={color}
                            paddingLeft={4}
                            colSpan={2}
                            title={`Alíquota de Imposto Calculada: ${adicionarPontosMilhar(props.dados.aliquota_calculada)}% = R$ ${adicionarPontosMilhar(
                                (props.dados.aliquota_calculada / 100) * subtotal
                            )}`}
                        >
                            Impostos (Base de Cálculo: R$ {adicionarPontosMilhar(subtotal)})
                        </Td>
                        <Td width={150} alignCenter>
                            N/A
                        </Td>
                        <Td width={100} alignCenter>
                            N/A
                        </Td>
                        <Td width={120} alignCenter>
                            R$ {adicionarPontosMilhar(totalImposto)}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450", backgroundColor: percentualEconomizado > 0 ? "#09cf6c" : "#cb0f31" }}>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Total
                        </Td>
                        <Td color="#ecf5fd" alignCenter>
                            =
                        </Td>
                        <Td color="#ecf5fd" width={120} alignCenter colSpan={2}>
                            <div>{"R$ " + adicionarPontosMilhar(totalComImposto) + ` (${adicionarPontosMilhar(Math.abs(percentualEconomizado || 0))}%)`}</div>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={5}>
                            {percentualEconomizado && (
                                <div style={{ filter: "brightness(1.1)" }}>
                                    <img
                                        src={percentualEconomizado > 0 ? avatarGradiosPositivo : avatarGradiosNegativo}
                                        alt={percentualEconomizado > 0 ? "Economizou" : "Não economizou"}
                                    />
                                </div>
                            )}
                        </Td>
                    </Tr>
                </TBody>
            </Table>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        filtro: state.diagnosticoEnergia.filtro,
        situacaoAtual: state.diagnosticoEnergia.situacaoAtual,
        listaTipoAnalise: state.diagnosticoEnergia.listaTipoAnalise,
        tarifasAneelSimulacao: state.diagnosticoEnergia.tarifasAneelSimulacao,
        listaSubgrupoFaturamento: state.cliente.listaSubgrupoFaturamento,
        listaModalidadeTarifaria: state.cliente.listaModalidadeTarifaria,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarTarifasSimulacaoOptante,
            setTarifasSimulacaoAneel,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RenderizarAnaliseOpcaoTarifariaOptanteBA);
